import MemberPortal from "./MemberPortal";

export default MemberPortal;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/index.js